const API_URL = process.env.REACT_APP_API_URL ?? ''; //Edit this to your API URL's path here. However, It is recommended to store your API's URL to .env file.

const APP_VERSION = process.env.REACT_APP_VERSION;

const IMAGE_URL = process.env.REACT_APP_IMAGE_URL;

const REACT_APP_ENV = process.env.REACT_APP_ENV;

export { API_URL, IMAGE_URL, APP_VERSION, REACT_APP_ENV };
